var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDictionary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08828 11.0833L8.05912 7.91667L6.99037 11.0833M7.34662 10.0146H8.73203M11.6256 7.91667H13.7235L11.6256 11.0833H13.7235M9.56526 9.5H11.1486M3.32495 2.57292V16.4271C3.32495 16.637 3.40836 16.8384 3.55683 16.9869C3.70529 17.1353 3.90665 17.2188 4.11662 17.2188H5.03891V1.78125H4.11662C3.90665 1.78125 3.70529 1.86466 3.55683 2.01312C3.40836 2.16159 3.32495 2.36295 3.32495 2.57292V2.57292Z",
    className: "svgStroke",
    strokeWidth: 0.59375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03894 1.78125V17.2188H14.8833C15.0933 17.2188 15.2946 17.1353 15.4431 16.9869C15.5916 16.8384 15.675 16.637 15.675 16.4271V2.57292C15.675 2.36295 15.5916 2.16159 15.4431 2.01312C15.2946 1.86466 15.0933 1.78125 14.8833 1.78125H5.03894Z",
    className: "svgStroke",
    strokeWidth: 0.59375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionary);
export default __webpack_public_path__ + "static/media/dictionary.5d65ced793f67e534a0ac839b9a62000.svg";
export { ForwardRef as ReactComponent };